import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import "./Header.css";
import { getUserInfo } from "../auth/helper";
import Logout from "../Logout/Logout";
import axios from "axios";
import { API } from "../backend";

const Header = ({ setIsLoginOpen, token, setToken }) => {
	const [isPopupVisible, setIsPopupVisible] = useState(false);
	const [userName, setUserName] = useState(null);
	const [isLogoutVisible, setIsLogoutVisible] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobileLogout, setIsMobileLogout] = useState(false);
  const [showMobileModal, setShowMobileModal] = useState(false);
  const navigate = useNavigate()

  const confirmMobileLogout = () => {
    setShowMobileModal(true);
    setIsMobileLogout(false)
    setIsMobileMenuOpen(false)
  };

  const handleProfileClick = () => {
    setIsLogoutVisible(false);
    setIsMobileMenuOpen(false)
    navigate("/mycourse");
  };

  const handleLogoutClick = async () => {
    const token = Cookies.get("token"); // Get token from cookies
    if (!token) return; // If no token, do nothing

    try {
      await axios.post(
        `${API}api/v1/user/logout/`,
        {},
        {
          headers: {
            Authorization: `Token ${token}`,
          },
        }
      );

      Cookies.remove("token");
      setToken(null);
      document.dispatchEvent(new Event("tokenChange"));
      setIsLogoutVisible(false);
      setIsMobileMenuOpen(false)
      setShowMobileModal(false);
      navigate("/");
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

	useEffect(() => {
		if (token) {
			getUserInfo(token).then((data) => {
				if (data && data.name) {
					setUserName(data.name);
				}
			});
		} else {
			setUserName(null);
		}
	}, [token]);

	const handleLoginClick = (event) => {
		event.stopPropagation();
		const token = Cookies.get("token");
		if (token) {
			setIsLogoutVisible((prev) => !prev);
		} else {
			setIsLoginOpen(true);
      setIsMobileMenuOpen(false)
		}
	};

  const handleLoginClickMobile = (event) => {
    event.stopPropagation();
    const token = Cookies.get("token");

    if (token) {
      setIsMobileLogout((prev) => !prev);
      

      } else {
      setIsLoginOpen(true);
      setIsMobileMenuOpen(false);
      }
  };

	useEffect(() => {
		const handleClickOutside = () => {
			setIsLogoutVisible(false);
		};

		document.addEventListener("click", handleClickOutside);
		return () => {
			document.removeEventListener("click", handleClickOutside);
		};
	}, []);

  const toggleMobileMenu = (event) => {
		event.stopPropagation();
		setIsMobileMenuOpen((prev) => !prev);
    setIsMobileLogout(false)
	};

	return (
		<>
			<div className="header_container">
        <div className="left_header">
          <button className="login_btn" onClick={handleLoginClick}>
            {userName ? userName : "ورود و ثبت نام"}
          </button>
        </div>
        <div className="right_header">
          <div className="option-container">
            <p className="responsive-text">تماس با ما</p>
            <p className="responsive-text">درباره ما</p>
            <p
              className={`with-icon responsive-text ${
                isPopupVisible ? "hovered" : ""
              }`}
              onMouseEnter={() => setIsPopupVisible(true)}
              onMouseLeave={() => setIsPopupVisible(false)}
            >
              دوره های آموزشی
            </p>
          </div>
          <div className="logo-container" onClick={() => navigate('/')}>
            <img
              src={require("../images/logo.png")}
              alt="logo"
              className="logo"
            />
          </div>
        </div>
      </div>

      <div
        className={`popup-courses ${isPopupVisible ? 'visible' : 'hidden'}`}
        onMouseEnter={() => setIsPopupVisible(true)}
        onMouseLeave={() => setIsPopupVisible(false)}
      >
        <div className='courses'>
          <div className='course-description'>
            <p className='course-title'>موسیقی</p>
            <p className='course-text'>زبان جهانی احساسات</p>
          </div>
          <div className='course-logo'>
            <svg className='course-svg' viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M18.3981 23.6547V19.8003H12.5428C10.2794 19.8003 8.36039 21.4647 8.04029 23.7054C7.61616 26.6742 10.1311 29.2337 13.107 28.8617L13.8877 28.7641C16.4644 28.442 18.3981 26.2516 18.3981 23.6547Z" fill="#E53B1F" />
              <path d="M18.3981 11.4003V10.5442C18.3981 8.27857 18.3981 7.14573 19.0617 6.36244C19.7252 5.57915 20.8427 5.39292 23.0775 5.02044L26.3769 4.47054C26.567 4.43885 26.6621 4.42301 26.7134 4.47857C26.7647 4.53413 26.7413 4.62764 26.6946 4.81464L25.4411 9.82843C25.4202 9.91198 25.4098 9.95375 25.3804 9.98175C25.3511 10.0098 25.3088 10.0182 25.2244 10.0351L18.3981 11.4003ZM18.3981 11.4003V19.8003M18.3981 19.8003V23.6547C18.3981 26.2516 16.4644 28.442 13.8877 28.7641L13.107 28.8617C10.1311 29.2337 7.61616 26.6742 8.04029 23.7054C8.36039 21.4647 10.2794 19.8003 12.5428 19.8003H18.3981Z" stroke="#E53B1F" stroke-width="2.8" />
            </svg>
          </div>
        </div>
        <div className='courses'>
          <div className='course-description'>
            <p className='course-title'>سینما</p>
            <p className='course-text'>هنر تصاویر متحرک</p>
          </div>
          <div className='course-logo'>
            <svg className='course-svg' viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M22.793 14.9968L13.647 10.4238C11.9714 9.58606 10 10.8045 10 12.6778V21.3229C10 23.1962 11.9714 24.4146 13.647 23.5769L22.793 19.0039C24.444 18.1784 24.444 15.8223 22.793 14.9968Z" fill="#E53B1F" />
            </svg>
          </div>
        </div>
        <div className='courses'>
          <div className='course-description'>
            <p className='course-title'>ارزمجازی</p>
            <p className='course-text'>امنیت و عدم تمرکز</p>
          </div>
          <div className='course-logo'>
            <svg className='course-svg' viewBox="0 0 17 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M15.6713 7.63009C15.4262 5.08634 13.2302 4.23353 10.4577 3.99064L10.4577 0.462028L8.30926 0.462396L8.30939 3.898C7.74533 3.89793 7.16816 3.90909 6.59474 3.92053L6.59506 0.462176L4.44838 0.462113L4.44759 3.98972C3.98257 3.99921 3.5259 4.00785 3.08062 4.00814L3.08034 3.9972L0.117945 3.99619L0.118509 6.29015C0.118509 6.29015 1.7046 6.25991 1.67824 6.28912C2.54823 6.28938 2.83195 6.7943 2.91374 7.23029L2.91393 11.2501C2.97396 11.2504 3.05228 11.2529 3.14095 11.2651L2.91464 11.2652L2.91352 16.8967C2.87534 17.1705 2.7144 17.6071 2.10658 17.6081C2.13406 17.6325 0.545264 17.6077 0.545264 17.6077L0.118653 20.1734L2.91433 20.1731C3.23007 20.1735 3.54274 20.1769 3.85197 20.1803L3.8524 20.1803C4.05245 20.1824 4.25106 20.1846 4.44814 20.1859L4.44919 23.7553L6.59472 23.7556L6.59523 20.2244C7.18375 20.2367 7.75385 20.2414 8.31043 20.2409L8.3095 23.7557L10.4573 23.7555L10.458 20.193C14.0689 19.9858 16.5968 19.076 16.9097 15.6859C17.163 12.9555 15.8792 11.737 13.8293 11.2442C15.0743 10.6089 15.8528 9.49168 15.6708 7.63023L15.6713 7.63009ZM12.6656 15.2611C12.6661 17.709 8.82001 17.655 7.06182 17.6304L7.06171 17.6304C6.90431 17.6282 6.76364 17.6262 6.64397 17.6263L6.64452 12.8978C6.79085 12.8979 6.96858 12.8937 7.16991 12.8889C8.97187 12.8464 12.6647 12.7592 12.6661 15.261L12.6656 15.2611ZM6.99803 10.7377C8.46593 10.7617 11.6656 10.8141 11.6662 8.59007C11.6665 6.31492 8.58822 6.3967 7.08484 6.43664C6.91584 6.44113 6.76673 6.44509 6.64414 6.44511L6.64402 10.7336C6.74521 10.7336 6.86445 10.7355 6.99803 10.7377Z" fill="#E53B1F" />
            </svg>
          </div>
        </div>
        <div className='courses'>
          <div className='course-description'>
            <p className='course-title'>علم داده</p>
            <p className='course-text'>کشف بینش از داده‌ها</p>
          </div>
          <div className='course-logo'>
            <svg className='course-svg' viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M26.8002 26.8005H7.2002" stroke="#E53B1F" stroke-width="2.8" stroke-linecap="round" />
              <path d="M15.6 19.8001V14.2001C15.6 12.6537 14.3464 11.4001 12.8 11.4001C11.2536 11.4001 10 12.6537 10 14.2001V19.8001C10 21.3465 11.2536 22.6001 12.8 22.6001C14.3464 22.6001 15.6 21.3465 15.6 19.8001Z" fill="#E53B1F" />
              <path d="M24.0006 19.8005V8.60054C24.0006 7.05414 22.747 5.80054 21.2006 5.80054C19.6542 5.80054 18.4006 7.05414 18.4006 8.60054V19.8005C18.4006 21.3469 19.6542 22.6005 21.2006 22.6005C22.747 22.6005 24.0006 21.3469 24.0006 19.8005Z" fill="#E53B1F" />
            </svg>
          </div>
        </div>
        <div className='courses'>
          <div className='course-description'>
            <p className='course-title'>ورزش</p>
            <p className='course-text'>فعالیت بدنی و سلامتی</p>
          </div>
          <div className='course-logo'>
            <svg className='course-svg' viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="17.3101" cy="17.3116" r="9.8" stroke="#E53B1F" stroke-width="2.8" />
              <path d="M7.04634 14.7552C8.35636 15.0532 9.59112 15.6174 10.6739 16.4127C11.7567 17.2079 12.6644 18.2174 13.3407 19.3782C14.0169 20.5391 14.4473 21.8266 14.605 23.1608C14.7627 24.495 14.6444 25.8474 14.2574 27.1339" stroke="#E53B1F" stroke-width="2.8" />
              <path d="M20.3855 7.41566C19.9885 8.69915 19.8597 10.0506 20.007 11.3859C20.1544 12.7213 20.5747 14.0121 21.2419 15.1782C21.9091 16.3443 22.809 17.3607 23.8856 18.1644C24.9622 18.9681 26.1925 19.5418 27.5002 19.8499" stroke="#E53B1F" stroke-width="2.8" />
            </svg>
          </div>
        </div>
      </div>
      {isLogoutVisible && (
        <div onClick={(e) => e.stopPropagation()}>
          <Logout setIsLogoutVisible={setIsLogoutVisible} setToken={setToken}/>
        </div>
      )}
      
			<div className="header_container-mobile">
        <div className="left-header-mobile">
          <svg className="mobile-btn" onClick={toggleMobileMenu} viewBox="0 0 32 32" fill="none">
            <rect width="32" height="32" rx="8" fill="#3CCFF1"/>
            <rect x="0.5" y="0.5" width="31" height="31" rx="7.5" stroke="black" stroke-opacity="0.1"/>
            <path d="M9 12H25" stroke="black" stroke-linecap="round"/>
            <path d="M9 19.5L17 19.5" stroke="black" stroke-linecap="round"/>
          </svg>
        </div>
        <div className="right-header-mobile">
          <div className="logo-container-mobile" onClick={() => navigate('/')}>
            <img
              src={require("../images/logo.png")}
              alt="logo"
              className="logo"
            />
          </div>
        </div>
      </div>

      {isMobileMenuOpen && <div className="overlay" onClick={toggleMobileMenu}></div>}

			<div className={`popup-mobile ${isMobileMenuOpen ? "visible" : "hidden"}`}>


        <button className="login_btn-mobile" onClick={handleLoginClickMobile}>
            {userName ? userName : "ورود و ثبت نام"}
        </button>

        <div className="course-horizontal-line-mobile"></div>

        {isMobileLogout ? (
          <>
          <div className="profile-logout-div-mobile" onClick={(e) => e.stopPropagation() || handleProfileClick()}>
            <p className="logout-title-mobile">پروفایل</p>
            <div className="logout-logo-mobile">
              <svg className="logout-svg-mobile" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="24" cy="16" r="7" stroke="#E53B1F" stroke-width="2" stroke-linecap="round" />
                <path d="M9.69826 33.8959C10.9777 29.2068 15.8295 27 20.69 27H27.31C32.1705 27 37.0223 29.2068 38.3017 33.8959C38.5641 34.8574 38.7736 35.8979 38.8923 37.0031C39.0104 38.1013 38.1046 39 37 39H11C9.89543 39 8.98964 38.1013 9.10765 37.0031C9.2264 35.8979 9.43592 34.8574 9.69826 33.8959Z" stroke="#3CCFF1" stroke-width="2" stroke-linecap="round" />
              </svg>
            </div>
          </div>
          <div className="profile-logout-div-mobile red" onClick={(e) => e.stopPropagation() || confirmMobileLogout()}>
            <p className="logout-title-mobile">خروج</p>
            <div className="logout-logo-mobile">
              <svg className="logout-svg-mobile" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M30.0272 6.3288L33.8758 5.68737C36.7466 5.2089 38.182 4.96966 39.3368 5.23358C41.2376 5.668 42.8088 6.999 43.5498 8.80255C44 9.89822 44 11.3534 44 14.2639V34.1319C44 36.6782 44 37.9513 43.6539 38.9257C42.9319 40.9579 41.1749 42.4464 39.0516 42.8244C38.0336 43.0056 36.7778 42.7963 34.2662 42.3777L34.2662 42.3777L30.0272 41.6712L30.0272 41.6712C25.2382 40.873 22.8438 40.474 21.4219 38.7955C20 37.117 20 34.6895 20 29.8345V18.1655C20 13.3105 20 10.883 21.4219 9.20451C22.8438 7.52604 25.2382 7.12696 30.0272 6.3288Z" fill="#FFFEF2" />
                <path d="M6 24L5.06296 23.2504L4.46325 24L5.06296 24.7496L6 24ZM24 25.2C24.6627 25.2 25.2 24.6627 25.2 24C25.2 23.3373 24.6627 22.8 24 22.8V25.2ZM13.063 13.2504L5.06296 23.2504L6.93704 24.7496L14.937 14.7496L13.063 13.2504ZM5.06296 24.7496L13.063 34.7496L14.937 33.2504L6.93704 23.2504L5.06296 24.7496ZM6 25.2H24V22.8H6V25.2Z" fill="#3CCFF1" />
              </svg>
            </div>
          </div>
        </>
        ) : (
        <>
          <div className='courses-mobile'>
            <div className='course-description-mobile'>
              <p className='course-title-mobile'>موسیقی</p>
              <p className='course-text-mobile'>زبان جهانی احساسات</p>
            </div>
            <div className='course-logo-mobile'>
              <svg className='course-svg-mobile' viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M18.3981 23.6547V19.8003H12.5428C10.2794 19.8003 8.36039 21.4647 8.04029 23.7054C7.61616 26.6742 10.1311 29.2337 13.107 28.8617L13.8877 28.7641C16.4644 28.442 18.3981 26.2516 18.3981 23.6547Z" fill="#E53B1F" />
                <path d="M18.3981 11.4003V10.5442C18.3981 8.27857 18.3981 7.14573 19.0617 6.36244C19.7252 5.57915 20.8427 5.39292 23.0775 5.02044L26.3769 4.47054C26.567 4.43885 26.6621 4.42301 26.7134 4.47857C26.7647 4.53413 26.7413 4.62764 26.6946 4.81464L25.4411 9.82843C25.4202 9.91198 25.4098 9.95375 25.3804 9.98175C25.3511 10.0098 25.3088 10.0182 25.2244 10.0351L18.3981 11.4003ZM18.3981 11.4003V19.8003M18.3981 19.8003V23.6547C18.3981 26.2516 16.4644 28.442 13.8877 28.7641L13.107 28.8617C10.1311 29.2337 7.61616 26.6742 8.04029 23.7054C8.36039 21.4647 10.2794 19.8003 12.5428 19.8003H18.3981Z" stroke="#E53B1F" stroke-width="2.8" />
              </svg>
            </div>
          </div>
          <div className='courses-mobile'>
            <div className='course-description-mobile'>
              <p className='course-title-mobile'>سینما</p>
              <p className='course-text-mobile'>هنر تصاویر متحرک</p>
            </div>
            <div className='course-logo-mobile'>
              <svg className='course-svg-mobile' viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22.793 14.9968L13.647 10.4238C11.9714 9.58606 10 10.8045 10 12.6778V21.3229C10 23.1962 11.9714 24.4146 13.647 23.5769L22.793 19.0039C24.444 18.1784 24.444 15.8223 22.793 14.9968Z" fill="#E53B1F" />
              </svg>
            </div>
          </div>
          <div className='courses-mobile'>
            <div className='course-description-mobile'>
              <p className='course-title-mobile'>ارزمجازی</p>
              <p className='course-text-mobile'>امنیت و عدم تمرکز</p>
            </div>
            <div className='course-logo-mobile'>
              <svg className='course-svg-mobile' viewBox="0 0 17 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M15.6713 7.63009C15.4262 5.08634 13.2302 4.23353 10.4577 3.99064L10.4577 0.462028L8.30926 0.462396L8.30939 3.898C7.74533 3.89793 7.16816 3.90909 6.59474 3.92053L6.59506 0.462176L4.44838 0.462113L4.44759 3.98972C3.98257 3.99921 3.5259 4.00785 3.08062 4.00814L3.08034 3.9972L0.117945 3.99619L0.118509 6.29015C0.118509 6.29015 1.7046 6.25991 1.67824 6.28912C2.54823 6.28938 2.83195 6.7943 2.91374 7.23029L2.91393 11.2501C2.97396 11.2504 3.05228 11.2529 3.14095 11.2651L2.91464 11.2652L2.91352 16.8967C2.87534 17.1705 2.7144 17.6071 2.10658 17.6081C2.13406 17.6325 0.545264 17.6077 0.545264 17.6077L0.118653 20.1734L2.91433 20.1731C3.23007 20.1735 3.54274 20.1769 3.85197 20.1803L3.8524 20.1803C4.05245 20.1824 4.25106 20.1846 4.44814 20.1859L4.44919 23.7553L6.59472 23.7556L6.59523 20.2244C7.18375 20.2367 7.75385 20.2414 8.31043 20.2409L8.3095 23.7557L10.4573 23.7555L10.458 20.193C14.0689 19.9858 16.5968 19.076 16.9097 15.6859C17.163 12.9555 15.8792 11.737 13.8293 11.2442C15.0743 10.6089 15.8528 9.49168 15.6708 7.63023L15.6713 7.63009ZM12.6656 15.2611C12.6661 17.709 8.82001 17.655 7.06182 17.6304L7.06171 17.6304C6.90431 17.6282 6.76364 17.6262 6.64397 17.6263L6.64452 12.8978C6.79085 12.8979 6.96858 12.8937 7.16991 12.8889C8.97187 12.8464 12.6647 12.7592 12.6661 15.261L12.6656 15.2611ZM6.99803 10.7377C8.46593 10.7617 11.6656 10.8141 11.6662 8.59007C11.6665 6.31492 8.58822 6.3967 7.08484 6.43664C6.91584 6.44113 6.76673 6.44509 6.64414 6.44511L6.64402 10.7336C6.74521 10.7336 6.86445 10.7355 6.99803 10.7377Z" fill="#E53B1F" />
              </svg>
            </div>
          </div>
          <div className='courses-mobile'>
            <div className='course-description-mobile'>
              <p className='course-title-mobile'>علم داده</p>
              <p className='course-text-mobile'>کشف بینش از داده‌ها</p>
            </div>
            <div className='course-logo-mobile'>
              <svg className='course-svg-mobile' viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M26.8002 26.8005H7.2002" stroke="#E53B1F" stroke-width="2.8" stroke-linecap="round" />
                <path d="M15.6 19.8001V14.2001C15.6 12.6537 14.3464 11.4001 12.8 11.4001C11.2536 11.4001 10 12.6537 10 14.2001V19.8001C10 21.3465 11.2536 22.6001 12.8 22.6001C14.3464 22.6001 15.6 21.3465 15.6 19.8001Z" fill="#E53B1F" />
                <path d="M24.0006 19.8005V8.60054C24.0006 7.05414 22.747 5.80054 21.2006 5.80054C19.6542 5.80054 18.4006 7.05414 18.4006 8.60054V19.8005C18.4006 21.3469 19.6542 22.6005 21.2006 22.6005C22.747 22.6005 24.0006 21.3469 24.0006 19.8005Z" fill="#E53B1F" />
              </svg>
            </div>
          </div>
          <div className='courses-mobile'>
            <div className='course-description-mobile'>
              <p className='course-title-mobile'>ورزش</p>
              <p className='course-text-mobile'>فعالیت بدنی و سلامتی</p>
            </div>
            <div className='course-logo-mobile'>
              <svg className='course-svg-mobile' viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="17.3101" cy="17.3116" r="9.8" stroke="#E53B1F" stroke-width="2.8" />
                <path d="M7.04634 14.7552C8.35636 15.0532 9.59112 15.6174 10.6739 16.4127C11.7567 17.2079 12.6644 18.2174 13.3407 19.3782C14.0169 20.5391 14.4473 21.8266 14.605 23.1608C14.7627 24.495 14.6444 25.8474 14.2574 27.1339" stroke="#E53B1F" stroke-width="2.8" />
                <path d="M20.3855 7.41566C19.9885 8.69915 19.8597 10.0506 20.007 11.3859C20.1544 12.7213 20.5747 14.0121 21.2419 15.1782C21.9091 16.3443 22.809 17.3607 23.8856 18.1644C24.9622 18.9681 26.1925 19.5418 27.5002 19.8499" stroke="#E53B1F" stroke-width="2.8" />
              </svg>
            </div>
          </div>
        </>
        )}
			</div>
      {showMobileModal && (
            <div className="logout-overlay-mobile" onClick={() => setShowMobileModal(false)}>
              <div className="logout-modal-mobile" onClick={(e) => e.stopPropagation()}>
                <svg className="logout-svg-modal-mobile" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M30.0272 6.3288L33.8758 5.68737C36.7466 5.2089 38.182 4.96966 39.3368 5.23358C41.2376 5.668 42.8088 6.999 43.5498 8.80255C44 9.89822 44 11.3534 44 14.2639V34.1319C44 36.6782 44 37.9513 43.6539 38.9257C42.9319 40.9579 41.1749 42.4464 39.0516 42.8244C38.0336 43.0056 36.7778 42.7963 34.2662 42.3777L34.2662 42.3777L30.0272 41.6712L30.0272 41.6712C25.2382 40.873 22.8438 40.474 21.4219 38.7955C20 37.117 20 34.6895 20 29.8345V18.1655C20 13.3105 20 10.883 21.4219 9.20451C22.8438 7.52604 25.2382 7.12696 30.0272 6.3288Z" fill="#3CCFF1" />
                  <path d="M6 24L5.06296 23.2504L4.46325 24L5.06296 24.7496L6 24ZM24 25.2C24.6627 25.2 25.2 24.6627 25.2 24C25.2 23.3373 24.6627 22.8 24 22.8V25.2ZM13.063 13.2504L5.06296 23.2504L6.93704 24.7496L14.937 14.7496L13.063 13.2504ZM5.06296 24.7496L13.063 34.7496L14.937 33.2504L6.93704 23.2504L5.06296 24.7496ZM6 25.2H24V22.8H6V25.2Z" fill="#E53B1F" />
                </svg>
                <p className='modal-title-mobile'>آیا مطمئن هستید که می‌خواهید خارج شوید؟</p>
                <div className="logout-buttons">
                  <button className="cancel-btn-mobile" onClick={() => setShowMobileModal(false)}>
                    خیر
                  </button>
                  <button className="confirm-btn-mobile" onClick={handleLogoutClick}>
                    بله
                  </button>
                </div>
              </div>
            </div>
      )}
		</>
	);
};

export default Header;
